import { DEPENDENT_SCHEMA } from 'lib/probate/estate-questionnaire-schema'

import { useAttributesRole } from '../shared-contacts/roles'
import SharedPeopleSection from '../shared-contacts/shared-people-section'
import useSectionToggle from '../use-section-toggle'

type Props = {
  sectionActive: boolean | undefined
  saveProbateEstateField: (event: { name: string; value: unknown }) => void
}

const Dependents = ({ sectionActive, saveProbateEstateField }: Props) => {
  const toggle = useSectionToggle({
    name: 'dependentsSectionActive',
    initialValue: sectionActive,
    save: saveProbateEstateField,
  })

  const role = useAttributesRole({
    isMember: ({ isDependent }) => !!isDependent,
    given: { isDependent: true },
    taken: { isDependent: false },
  })

  return (
    <SharedPeopleSection
      heading="4.3 Dependents"
      type="Dependent"
      addLabel="Add dependent"
      role={role}
      schema={DEPENDENT_SCHEMA}
      toggle={toggle}
    />
  )
}

export default Dependents
